module.exports = __webpack_public_path__ + "static/media/stock-2.4412962f.jpg";